import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICustomerDiscountCodesData } from "../../api/discounts/index.types";

export interface IDiscountCodes {
  codes: ICustomerDiscountCodesData[];
  count: number;
}

export interface IUserDiscountCodesState {
  data: {
    [id: number]: {
      codes: ICustomerDiscountCodesData[];
      count: number;
    };
  };
  loading: boolean;
}

const initialState: IUserDiscountCodesState = {
  data: {},
  loading: false,
};

interface FetchSuccessPayload {
  discountCodes: IDiscountCodes;
  id: number;
}

const index = createSlice({
  name: "userDiscount",
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true;
    },
    fetchSuccess: (state, action: PayloadAction<FetchSuccessPayload>) => {
      state.loading = false;
      state.data[action.payload.id] = action.payload.discountCodes;
    },
    fetchFailed: (state) => {
      state.loading = false;
    },
  },
});

export const userDiscountActions = index.actions;
export default index.reducer;
